module.exports = __webpack_public_path__ + "static/digital-art-2-5275895d144b0fa7a7dc59803b0826db.png";